import React from "react";
import styled from "styled-components";
import { mdiChevronDown, mdiChevronRight } from "@mdi/js";
import { Svg } from "./Svg";

const AccordionStyle = styled.div`
    border-radius: 2px;
    background-color: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.greyLight};
`;

const HeaderStyle = styled.div`
    gap: 12px;
    display: flex;
    cursor: pointer;
    user-select: none;
    align-items: center;
    padding: 8px 14px 8px 8px;
    &:hover {
        background-color: ${props => props.theme.greyLightest};
    }
    &.active {
        background-color: ${props => props.theme.greyLightest};
        border-bottom: 1px solid ${props => props.theme.greyLight};
    }
    >svg {
        flex: none;
    }
`;

const HeaderContentStyle = styled.div`
    flex-grow: 1;
    min-width: 0;
`;

// the content stays mounted while collapsed, so inputs inside keep their validation
const ContentStyle = styled.div`
    display: none;
    &.active {
        display: block;
    }
`;

export const Accordion = props => {

    const { header, expanded, children, dragProps } = props;

    // controls inside the header (checkbox, buttons, inputs) must not toggle the accordion
    const onClick = event => {
        if (event.target.closest("button, input") === null) {
            props.onChange(!expanded);
        }
    };

    // the header is the drag handle (SortableList): a draggable body would break text selection in its inputs
    return (
        <AccordionStyle>
            <HeaderStyle
                {...dragProps}
                onClick={onClick}
                className={expanded ? "active" : ""}>
                <Svg path={expanded ? mdiChevronDown : mdiChevronRight} size="22" highlight />
                <HeaderContentStyle>
                    {header}
                </HeaderContentStyle>
            </HeaderStyle>
            <ContentStyle className={expanded ? "active" : ""}>
                {children}
            </ContentStyle>
        </AccordionStyle>
    );
};
